module.exports = __webpack_public_path__ + "img/icon-news-sidebar.70f41b0b.svg";